module.exports = "/_next/static/resources/earth-6a13be221d0b0b8667de424c538fb24d.jpg";